import React from 'react';
import { Box, constants, Typography } from '@match/react-component-library';

const { FONT_SIZE, FONT_WEIGHT, SPACE } = constants;

// Purposefully not adding this to Crowdin.
const TermsModalContentJapan = () => {
  return (
    <React.Fragment>
      <Box marginBottom={SPACE.LARGE} textAlign="center" width="100%">
        <Typography fontSize={FONT_SIZE.LARGE} fontWeight={FONT_WEIGHT.BOLD}>
          Match幸せレポートのサイト利用規約
        </Typography>
      </Box>
      <Box marginBottom={SPACE.LARGE}>
        Match幸せレポートのサイト（以下「幸せレポートのサイト」と呼びます。運営元: Match Global
        Services Limited, 8750 N. Central Expressway, Suite 1400, Dallas, TX 75205,
        USA）では、Matchで出会ったカップルが、自分たちの写真、エピソード、Matchを最大限に活用するためのヒントなどを投稿することができます。Match幸せレポートのサイトは、Matchで出会ったカップルが自分たちの成功を世界中の人々に共有する機会を提供しています。幸せレポートのサイトを利用することで、あなたはMatch幸せレポートのサイトの利用規約だけでなく、
        <a href="https://jp.match.com/registration/membagr.aspx" target="_blank">
          Match.com利用規約
        </a>{' '}
        <a href="https://jp.match.com/registration/privacystatement.aspx" target="_blank">
          およびプライバシーポリシー
        </a>
        にしたがうことに同意します。
      </Box>
      <Box marginBottom={SPACE.MEDIUM}>A. Match幸せレポートのサイトのユーザー</Box>
      <Box marginBottom={SPACE.MEDIUM}>
        Matchで出会ったカップルは幸せレポートのサイトで、自分たちのデートのエピソード、写真、ヒントを提出し、それらをMatchでのみ共有するか、またはC下記（C）項に記載されているようにMatchが外部のソーシャルメディアやその他で公開することを許可するかを選択できます。
      </Box>
      <Box marginBottom={SPACE.MEDIUM}>B. 幸せレポートのエピソード、写真、ヒントの提出</Box>
      <Box marginBottom={SPACE.MEDIUM}>
        幸せレポートのサイトにエピソードを提出するには、あなたとお相手の身元がわかる情報およびお二人の関係についての情報（例：交際状況）を提供する必要があります。さらに、（a）お二人のエピソードと（b）お二人の写真（aとbをあわせて「幸せレポート」と呼びます）を提供する必要があります。また、幸せレポートとあわせて、Matchを最大限に活用するためのヒントを提出することもできます。ご提出いただいたヒントは、お二人の幸せレポートの一部とみなされます。あなたとお相手が下記（C）項に記載されているとおりMatchがお二人の幸せレポートを外部メディアで共有することを許可した場合、Matchはお二人の幸せレポートの内容の一部を使用することができます。たとえば、写真やヒントを除いたエピソードのみを使用したり、エピソードを除いたヒントまたは写真のみを使用したりすることがあります。あなたとお相手はお二人のエピソードまたは写真に載っているすべての人から明示的な許可を得る必要があります。幸せレポートのサイトに内容を提出することで、あなたとお相手は以下について同意および表明します。（i）Matchはお二人の内容のすべてもしくは一部を使用し、または何も使用しないことができます。（ii）あなたとお相手の両方がこれらの利用規約に同意します。（iii）（下記で定義されている外部使用を選択した場合）あなたとお相手の両方がお二人のエピソードと写真を公開することに同意します。（iv）提出した情報や資料はすべて真実かつ正確です。（v）提出はあなたとお相手に課せられたいかなる義務や制限にも抵触せず、第三者の著作権その他の権利を一切侵害しません。(vi)あなたとお相手は幸せレポートの著作者人格権及び実演家人格権を行使せず、第三者をしてこれらを行使させません。(vii)あなたとお相手は本件に関してMatchから開示された情報を第三者に開示又は漏洩しません。あなたとお相手はこの同意に違反した結果、またはこれらの表明が虚偽であった場合にもたらされるあらゆる損害を補償し、Matchに損害を与えないことに同意します。
      </Box>
      <Box marginBottom={SPACE.MEDIUM}>C. 幸せレポートのエピソード、写真、ヒントの使用</Box>
      <Box marginBottom={SPACE.MEDIUM}>
        幸せレポートを提出し、幸せレポートをソーシャルメディアその他で共有するオプション（以下「外部使用」といいます）を選択することで、あなたとお相手の両方は、Matchがお二人の幸せレポート（またはその一部）を（i）Matchのウェブサイトまたは関連アプリ、（ii）Matchのブログ、（iii）ソーシャルメディア、（iv）Match会員へ配信されるメール、(v)
        プレスリリースなどの広報資料、放送、出版、印刷物、屋外広告物、商品、その他Matchが利用するあらゆる媒体で使用する無条件の権利と許可を与えます。さらに、外部使用を選択した場合、あなたはMatchが（a）メディアにあなたの連絡先の情報を提供し（ただし、連絡先の提供はあなたが書面（メールも可）で同意した場合に限ります。）、（b）あなたのメールアドレスその他の連絡先に連絡し（当該連絡先情報が提供されている場合。また、Matchの委託先があなたに連絡する場合を含みます。）、又は（c）お二人の幸せレポートまたはその一部を本項で記載されている使用の必要に応じて転載する権利を与えます。Matchはお二人の幸せレポートをわかりやすい内容に書き換えたり、要約したりして編集する場合があります。Matchはお二人の幸せレポートを２年間使用することができますが、使用する義務はありません。本件レポートが第三者により不正使用等され、お二人が損害を被った場合も、Matchは当該損害に関して責任を負いません。幸せレポートのサイトに提出され、Matchが外部で使用した内容は、Matchがその内容を削除又は掲載停止するまで掲載または公開され続けます。Matchはいつでも幸せレポートのサイトを廃止する権利を保有します。
        Matchは、i) Matchで出会い、ii)幸せレポートを提出し、iii)
        幸せレポートを提出する12ヶ月以内にMatchを退会したカップルへプレゼントを贈ることがありますが、その義務はありません。あなたは、この幸せレポートを提出することで、Matchの会員であったことと、幸せレポートの提出12ヶ月以内にMatchを退会したことを確認します。
      </Box>
      <Box marginBottom={SPACE.MEDIUM}>D. お問い合わせ</Box>

      <Box marginBottom={SPACE.MEDIUM}>
        Matchでは、幸せレポートをご提出していただいてから、2年間幸せレポートを保管しています。
        <Box marginY={SPACE.MEDIUM}>
          ご交際を終了した方で、幸せレポートの掲載を取り下げたい方は、
          <strong>
            <a href="https://jp.match.com/community/contact-us" target="_blank">
              こちら
            </a>
          </strong>{' '}
          までご連絡ください。あなたの幸せレポートの公開を停止します
        </Box>
        情報の開示（幸せレポートの利用方法など）、訂正・削除（幸せレポートの撤回など）をご希望の場合は、
        <strong>
          <a href="https://jp.match.com/community/contact-us" target="_blank">
            こちら
          </a>
        </strong>{' '}
        までご連絡ください。Match所定の請求手続きに従い、ご本人からの請求であることを確認した上で、対応させていただきます。
      </Box>
    </React.Fragment>
  );
};

export default TermsModalContentJapan;
